"use strict";
/**
 * Updated for new UI design (v2)
 * Changes made:
 * 1. Removed all code related to `ZippedCodeBlock`.
 * 2. Removed `tech` and `pro` code related to modifier codes.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.transactionAccordianBuilderV2 = void 0;
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var transaction_headerV2_1 = require("./transaction-headerV2");
var transaction_bodyV2_1 = require("./transaction-bodyV2");
/**
 * Method that builds an accordion element
 * @param handleUnitsChange
 * @param handleCodeDelete
 * @param handleEnableTechPro
 * @param handleDisableTechPro
 * @param onFeatureSelection
 * @param panelActivations
 * @param medicalCode
 * @param idx
 * @param errors
 * @returns
 */
var transactionAccordianBuilderV2 = function (handleUnitsChange, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup, onSearch, onSearchSelection, onAddAllCodes, onRemoveAllCodes, codeDropHandler, onDropHandler, onAccordionAction, onDelete, suggestedCodes, searchResults, invoice, codeEdits, editable, autoFocus, codableTransaction, transaction, errors, items) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (errors === void 0) { errors = []; }
    var styleClasses = '';
    var techTransaction = {
        proCode: null,
        techCode: null,
        hasProCode: false,
        hasTechCode: false,
        isProCodeActive: false,
        isTechCodeActive: false,
        proContext: null,
        techContext: null,
        isModifier: false,
        isLoading: false
    };
    techTransaction.isLoading = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.isLoadingTechPro) !== null && _a !== void 0 ? _a : false;
    styleClasses = 'transaction-section';
    // assign tech/pro code if it exists
    // removing procedure with provenance TECH
    var procedureCode = [codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.codes, transaction === null || transaction === void 0 ? void 0 : transaction.codes]
        .flatMap(function (codes) { return codes || []; })
        .find(function (code) {
        return ui_common_1.cmxTypeguards.isChargeSessionCode(code) &&
            code.codeType === 'procedure' &&
            code.provenance !== 'TECH';
    });
    if (codableTransaction && procedureCode) {
        techTransaction.isModifier = false;
        // add tech/pro for procedure
        techTransaction.proCode =
            (_c = (_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _b === void 0 ? void 0 : _b.procedure_code) !== null && _c !== void 0 ? _c : null;
        techTransaction.techCode = (_e = (_d = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : null;
        techTransaction.hasProCode = !!((_f = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _f === void 0 ? void 0 : _f.procedure_code);
        techTransaction.hasTechCode = !!((_g = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _g === void 0 ? void 0 : _g.code);
        techTransaction.isProCodeActive = techTransaction.hasProCode
            ? (_h = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _h === void 0 ? void 0 : _h.active
            : false;
        techTransaction.isTechCodeActive = techTransaction.hasTechCode
            ? (_j = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _j === void 0 ? void 0 : _j.active
            : false;
        techTransaction.proContext = {
            transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
            mappedProcedure: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) || null
        };
        techTransaction.techContext = {
            transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
            technicalCode: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) || null
        };
    }
    return {
        className: (0, classnames_1["default"])(styleClasses),
        header: (0, transaction_headerV2_1.TransactionHeader)(procedureCode, techTransaction, errors, invoice, codeEdits, handleUnitsChange, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, codeDropHandler, isTimeBasedCode, timeBasedCodePopup, onSearch, onSearchSelection, onAddAllCodes, onRemoveAllCodes, searchResults, codableTransaction, transaction, editable, suggestedCodes, autoFocus),
        id: 0,
        body: (0, transaction_bodyV2_1.TransactionBuildBody)(codableTransaction, onDropHandler, onAccordionAction, items, onDelete, editable)
    };
};
exports.transactionAccordianBuilderV2 = transactionAccordianBuilderV2;
//# sourceMappingURL=transaction-accordionV2.js.map